import {
    FETCH_COST_VALUE_DRIVER,
    ADD_VALUE_MODEL,
    FETCH_VALUE_MODEL,
    FETCH_VALUE_MODELS,
    SHOW_ERROR,
    ADD_COST_VALUE_DRIVER_LABOR,
    EDIT_COST_VALUE_DRIVER_LABOR,
    DELETE_COST_VALUE_DRIVER_LABOR,
    ADD_COST_VALUE_DRIVER_CS,
    EDIT_COST_VALUE_DRIVER_CS,
    DELETE_COST_VALUE_DRIVER_CS,
    ADD_COST_VALUE_DRIVER_OPERATING,
    EDIT_COST_VALUE_DRIVER_OPERATING,
    DELETE_COST_VALUE_DRIVER_OPERATING,
    ADD_COST_VALUE_DRIVER_RANDD,
    EDIT_COST_VALUE_DRIVER_RANDD,
    DELETE_COST_VALUE_DRIVER_RANDD,
    ADD_COST_VALUE_DRIVER_INVESTMENT,
    EDIT_COST_VALUE_DRIVER_INVESTMENT,
    DELETE_COST_VALUE_DRIVER_INVESTMENT,
    ADD_COST_VALUE_DRIVER_COMPLIANCE,
    EDIT_COST_VALUE_DRIVER_COMPLIANCE,
    DELETE_COST_VALUE_DRIVER_COMPLIANCE,
    ADD_COST_VALUE_DRIVER_INVENTORY,
    EDIT_COST_VALUE_DRIVER_INVENTORY,
    DELETE_COST_VALUE_DRIVER_INVENTORY,
    ADD_COST_VALUE_DRIVER_FACILITY,
    EDIT_COST_VALUE_DRIVER_FACILITY,
    DELETE_COST_VALUE_DRIVER_FACILITY,
    ADD_COST_VALUE_DRIVER_EQUIPMENT,
    EDIT_COST_VALUE_DRIVER_EQUIPMENT,
    DELETE_COST_VALUE_DRIVER_EQUIPMENT,
    ADD_COST_VALUE_DRIVER_UPGRADE,
    EDIT_COST_VALUE_DRIVER_UPGRADE,
    DELETE_COST_VALUE_DRIVER_UPGRADE,
    ADD_REVENUE_VALUE_DRIVER_TTM,
    EDIT_REVENUE_VALUE_DRIVER_TTM,
    DELETE_REVENUE_VALUE_DRIVER_TTM,
    ADD_REVENUE_VALUE_DRIVER_SALES,
    EDIT_REVENUE_VALUE_DRIVER_SALES,
    DELETE_REVENUE_VALUE_DRIVER_SALES,
    ADD_REVENUE_VALUE_DRIVER_MARKETING,
    EDIT_REVENUE_VALUE_DRIVER_MARKETING,
    DELETE_REVENUE_VALUE_DRIVER_MARKETING,
    ADD_REVENUE_VALUE_DRIVER_CLV,
    EDIT_REVENUE_VALUE_DRIVER_CLV,
    DELETE_REVENUE_VALUE_DRIVER_CLV,
    EDIT_VARIABLE_VALUES,
    VIEW_VALUE_MODEL,
    HIDE_ERROR,
    ADD_REVENUE_VALUE_DRIVER_IR,
    EDIT_REVENUE_VALUE_DRIVER_IR,
    DELETE_REVENUE_VALUE_DRIVER_IR,
    CLEAR_COST_VALUE_DRIVER,
    ADD_RISK_VALUE_DRIVER_REGULATORY,
    EDIT_RISK_VALUE_DRIVER_REGULATORY,
    DELETE_RISK_VALUE_DRIVER_REGULATORY,
    ADD_RISK_VALUE_DRIVER_LITIGATION,
    EDIT_RISK_VALUE_DRIVER_LITIGATION,
    DELETE_RISK_VALUE_DRIVER_LITIGATION,
    ADD_RISK_VALUE_DRIVER_REVENUE,
    EDIT_RISK_VALUE_DRIVER_REVENUE,
    DELETE_RISK_VALUE_DRIVER_REVENUE,
    QUERY_COST_ITEM,
    CLEAR_QUERY_RESULT,
    ADD_DATA,
    QUERY_COST_TYPE,
    QUERY_EMPLOYEE_TYPE,
    QUERY_EMPLOYEE_CATEGORY,
    QUERY_INVESTMENT_PROJECT,
    QUERY_INVESTMENT_ASSET,
    QUERY_PRODUCT_TYPE,
    QUERY_REVENUE_TYPE,
    FETCH_IMPACT_ANALYSIS,
    ADD_IMPACT_AREA,
    EDIT_IMPACT_ANALYSIS,
    FETCH_DRIVER_ANALYSIS,
    ADD_COST_VALUE_DRIVER_ACCOUNTING,
    ADD_COST_VALUE_DRIVER_HR,
    ADD_COST_VALUE_DRIVER_BD,
    ADD_COST_VALUE_DRIVER_MARCOM,
    ADD_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
    ADD_COST_VALUE_DRIVER_IT,
    ADD_COST_VALUE_DRIVER_LEGAL,
    ADD_COST_VALUE_DRIVER_PROCUREMENT,
    EDIT_COST_VALUE_DRIVER_ACCOUNTING,
    EDIT_COST_VALUE_DRIVER_HR,
    EDIT_COST_VALUE_DRIVER_BD,
    EDIT_COST_VALUE_DRIVER_MARCOM,
    EDIT_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
    EDIT_COST_VALUE_DRIVER_IT,
    EDIT_COST_VALUE_DRIVER_LEGAL,
    EDIT_COST_VALUE_DRIVER_PROCUREMENT,
    DELETE_COST_VALUE_DRIVER_ACCOUNTING,
    DELETE_COST_VALUE_DRIVER_HR,
    DELETE_COST_VALUE_DRIVER_BD,
    DELETE_COST_VALUE_DRIVER_MARCOM,
    DELETE_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
    DELETE_COST_VALUE_DRIVER_IT,
    DELETE_COST_VALUE_DRIVER_LEGAL,
    DELETE_COST_VALUE_DRIVER_PROCUREMENT,
    ADD_COST_VALUE_DRIVER_PAYMENT,
    EDIT_COST_VALUE_DRIVER_PAYMENT,
    DELETE_COST_VALUE_DRIVER_PAYMENT,
    EDIT_REVENUE_MODEL,
} from './types';
import errorObject from '../components/helpers/errorObject';
import history from '../history';
import auth from '../apis/auth';

const dispatchType = {
    add: {
        operating: ADD_COST_VALUE_DRIVER_OPERATING,
        accounting: ADD_COST_VALUE_DRIVER_ACCOUNTING,
        hr: ADD_COST_VALUE_DRIVER_HR,
        bd: ADD_COST_VALUE_DRIVER_BD,
        marcom: ADD_COST_VALUE_DRIVER_MARCOM,
        customer_success: ADD_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
        it: ADD_COST_VALUE_DRIVER_IT,
        legal: ADD_COST_VALUE_DRIVER_LEGAL,
        procurement: ADD_COST_VALUE_DRIVER_PROCUREMENT,
        investment: ADD_COST_VALUE_DRIVER_INVESTMENT,
        randd: ADD_COST_VALUE_DRIVER_RANDD,
        compliance: ADD_COST_VALUE_DRIVER_COMPLIANCE,
        labor: ADD_COST_VALUE_DRIVER_LABOR,
        cs: ADD_COST_VALUE_DRIVER_CS,
        inventory: ADD_COST_VALUE_DRIVER_INVENTORY,
        payment: ADD_COST_VALUE_DRIVER_PAYMENT,
        facility: ADD_COST_VALUE_DRIVER_FACILITY,
        equipment: ADD_COST_VALUE_DRIVER_EQUIPMENT,
        upgrade: ADD_COST_VALUE_DRIVER_UPGRADE,
        sales: ADD_REVENUE_VALUE_DRIVER_SALES,
        marketing: ADD_REVENUE_VALUE_DRIVER_MARKETING,
        ttm: ADD_REVENUE_VALUE_DRIVER_TTM,
        clv: ADD_REVENUE_VALUE_DRIVER_CLV,
        incremental: ADD_REVENUE_VALUE_DRIVER_IR,
        regulatory: ADD_RISK_VALUE_DRIVER_REGULATORY,
        litigation: ADD_RISK_VALUE_DRIVER_LITIGATION,
        loss: ADD_RISK_VALUE_DRIVER_REVENUE,
    },
    edit: {
        operating: EDIT_COST_VALUE_DRIVER_OPERATING,
        accounting: EDIT_COST_VALUE_DRIVER_ACCOUNTING,
        hr: EDIT_COST_VALUE_DRIVER_HR,
        bd: EDIT_COST_VALUE_DRIVER_BD,
        marcom: EDIT_COST_VALUE_DRIVER_MARCOM,
        customer_success: EDIT_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
        it: EDIT_COST_VALUE_DRIVER_IT,
        legal: EDIT_COST_VALUE_DRIVER_LEGAL,
        procurement: EDIT_COST_VALUE_DRIVER_PROCUREMENT,        
        investment: EDIT_COST_VALUE_DRIVER_INVESTMENT,
        randd: EDIT_COST_VALUE_DRIVER_RANDD,
        compliance: EDIT_COST_VALUE_DRIVER_COMPLIANCE,
        labor: EDIT_COST_VALUE_DRIVER_LABOR,
        cs: EDIT_COST_VALUE_DRIVER_CS,
        inventory: EDIT_COST_VALUE_DRIVER_INVENTORY,
        payment: EDIT_COST_VALUE_DRIVER_PAYMENT,
        facility: EDIT_COST_VALUE_DRIVER_FACILITY,
        equipment: EDIT_COST_VALUE_DRIVER_EQUIPMENT,
        upgrade: EDIT_COST_VALUE_DRIVER_UPGRADE,
        sales: EDIT_REVENUE_VALUE_DRIVER_SALES,
        marketing: EDIT_REVENUE_VALUE_DRIVER_MARKETING,
        ttm: EDIT_REVENUE_VALUE_DRIVER_TTM,
        clv: EDIT_REVENUE_VALUE_DRIVER_CLV,
        incremental: EDIT_REVENUE_VALUE_DRIVER_IR,
        regulatory: EDIT_RISK_VALUE_DRIVER_REGULATORY,
        litigation: EDIT_RISK_VALUE_DRIVER_LITIGATION,
        loss: EDIT_RISK_VALUE_DRIVER_REVENUE,
    },
    delete: {
        operating: DELETE_COST_VALUE_DRIVER_OPERATING,
        accounting: DELETE_COST_VALUE_DRIVER_ACCOUNTING,
        hr: DELETE_COST_VALUE_DRIVER_HR,
        bd: DELETE_COST_VALUE_DRIVER_BD,
        marcom: DELETE_COST_VALUE_DRIVER_MARCOM,
        customer_success: DELETE_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
        it: DELETE_COST_VALUE_DRIVER_IT,
        legal: DELETE_COST_VALUE_DRIVER_LEGAL,
        procurement: DELETE_COST_VALUE_DRIVER_PROCUREMENT,        
        investment: DELETE_COST_VALUE_DRIVER_INVESTMENT,
        randd: DELETE_COST_VALUE_DRIVER_RANDD,
        compliance: DELETE_COST_VALUE_DRIVER_COMPLIANCE,
        labor: DELETE_COST_VALUE_DRIVER_LABOR,
        cs: DELETE_COST_VALUE_DRIVER_CS,
        inventory: DELETE_COST_VALUE_DRIVER_INVENTORY,
        payment: DELETE_COST_VALUE_DRIVER_PAYMENT,
        facility: DELETE_COST_VALUE_DRIVER_FACILITY,
        equipment: DELETE_COST_VALUE_DRIVER_EQUIPMENT,
        upgrade: DELETE_COST_VALUE_DRIVER_UPGRADE,
        sales: DELETE_REVENUE_VALUE_DRIVER_SALES,
        marketing: DELETE_REVENUE_VALUE_DRIVER_MARKETING,
        ttm: DELETE_REVENUE_VALUE_DRIVER_TTM,
        clv: DELETE_REVENUE_VALUE_DRIVER_CLV,
        incremental: DELETE_REVENUE_VALUE_DRIVER_IR,
        regulatory: DELETE_RISK_VALUE_DRIVER_REGULATORY,
        litigation: DELETE_RISK_VALUE_DRIVER_LITIGATION,
        loss: DELETE_RISK_VALUE_DRIVER_REVENUE
    }
}

export const fetchCostValueDriver = (id) => async dispatch => {
    await auth.get(`/api/value/get_cost_drivers?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_COST_VALUE_DRIVER, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/value-models')
        })
}

export const clearCostValueDriver = () => async dispatch => {
    dispatch({ type: CLEAR_COST_VALUE_DRIVER });
}

export const addValueModel = (formValues) => async dispatch => {
    await auth.post('/api/value/create_value_model', formValues)
        .then(response => {
            const id = response.data.id
            dispatch({ type: ADD_VALUE_MODEL, payload: response.data })
            dispatch(fetchImpactAnalysis(id))
            history.push(`/value-models/value-model?id=${id}`)
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchValueModel = (id) => async dispatch => {
    await auth.get(`/api/value/get_value_model?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_VALUE_MODEL, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/value-models')
        })
}

export const fetchValueModels = () => async dispatch => {
    await auth.get('/api/value/get_value_models')
        .then(response => {
            dispatch({ type: FETCH_VALUE_MODELS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const addDriver = (type, id, formValues, { setSubmitting, setErrors }) => async dispatch => {
    return auth.post(`/api/value/add_driver?id=${id}&type=${type}`, formValues)
        .then(response => {
            dispatch({ type: dispatchType.add[type], payload: response.data })
            dispatch({ type: HIDE_ERROR })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail);
                dispatch({ type: SHOW_ERROR, payload: errorObj });
                setErrors(errorObj);

                // Return a success response
                return { success: false };
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });

                // Return a success response
                return { success: false };
            }
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const editDriver = (type, id, formValues, { setSubmitting, setErrors }) => async dispatch => {
    return auth.patch(`/api/value/update_driver?id=${id}&type=${type}`, formValues)
        .then(response => {
            dispatch({ type: dispatchType.edit[type], payload: response.data })
            dispatch({ type: HIDE_ERROR })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
                setErrors(errorObj);

                // Return a success response
                return { success: false };
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });

                // Return a success response
                return { success: false };
            }
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const deleteDriver = (type, id, driver_id) => async dispatch => {
    await auth.delete(`/api/value/delete_driver?id=${id}&driver_id=${driver_id}&type=${type}`)
        .then(response => {
            dispatch({ type: dispatchType.delete[type], payload: response.data })
            dispatch({ type: HIDE_ERROR })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const editVariableValues = (id, formValues) => async dispatch => {
    await auth.patch(`/api/value/update_variables?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: EDIT_VARIABLE_VALUES, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchViewValueModel = (id, variables) => async dispatch => {
    await auth.get(`/api/value/view_value_model?id=${id}&variables=${JSON.stringify(variables)}`)
        .then(response => {
            dispatch({ type: VIEW_VALUE_MODEL, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/value-models')
        })
}

export const queryEmployeeType = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_employee_type?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_EMPLOYEE_TYPE, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryEmployeeCategory = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_employee_category?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_EMPLOYEE_CATEGORY, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryCostItem = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_cost_item?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_COST_ITEM, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryCostType = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_cost_type?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_COST_TYPE, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryInvestmentProject = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_investment_project?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_INVESTMENT_PROJECT, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryInvestmentAsset = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_investment_asset?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_INVESTMENT_ASSET, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryProductType = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_product_type?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_PRODUCT_TYPE, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const queryRevenueType = (id, formValues, { setSubmitting }) => async dispatch => {
    return auth.post(`/api/query/query_revenue_type?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: QUERY_REVENUE_TYPE, payload: response.data })

            // Return a success response
            return { success: true };
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });

            // Return a success response that is false
            return { success: false };
        })
        .finally(() => {
            setSubmitting(false)
        })
}

export const clearQueryResult = () => async dispatch => {
    dispatch({ type: CLEAR_QUERY_RESULT });
}

export const addData = (id, type, data_type, formValues) => async dispatch => {
    await auth.post(`/api/value/add_data?id=${id}&type=${type}&data_type=${data_type}`, formValues)
        .then(response => {
            dispatch({ type: ADD_DATA, payload: response.data })

            dispatch(fetchCostValueDriver(id))
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const queryValueProposition = async (formValues) => {
    try {
        const response = await auth.post(
            '/api/query/find_value_prop', formValues
        );
        return { success: true, data: response.data };
    } catch (error) {
        // Handle the error here or rethrow it
        return { success: false };
    }
};

export const fetchImpactAnalysis = (id) => async dispatch => {
    await auth.get(`/api/value/get_impact_analysis?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_IMPACT_ANALYSIS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push(`/value-models?id=${id}`)
        })
}

export const addImpactArea = (id, formValues) => async dispatch => {
    await auth.post(`/api/value/add_impact_area?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: ADD_IMPACT_AREA, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const editImpactAnalysis = (id, formValues) => async dispatch => {
    await auth.post(`/api/value/update_impact_analysis?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: EDIT_IMPACT_ANALYSIS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const fetchDriverAnalysis = (id) => async dispatch => {
    await auth.get(`/api/value/get_driver_analysis?id=${id}`)
        .then(response => {
            dispatch({ type: FETCH_DRIVER_ANALYSIS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const editRevenueModel = (id, formValues) => async dispatch => {
    await auth.patch(`/api/value/update_revenue_model?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: EDIT_REVENUE_MODEL, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}